module.exports = __webpack_public_path__ + "static/media/paso 1.994b200f.png";